import { createTypes } from '../../utils/helpers';

const RESTAURANTS_FETCH_ENTITIES: any = createTypes(
  'RESTAURANTS_FETCH_ENTITIES',
);
const RESTAURANTS_FETCH_ENTITY: any = createTypes('RESTAURANTS_FETCH_ENTITY');
const RESTAURANTS_CLEAR_ENTITIES = 'RESTAURANTS_CLEAR_ENTITIES';
const RESTAURANTS_SET_ROWS_PER_PAGE = 'RESTAURANTS_SET_ROWS_PER_PAGE';
const RESTAURANTS_SET_PAGE = 'RESTAURANTS_SET_PAGE';
const RESTAURANTS_CLEAR_PAGINATION_INFO = 'RESTAURANTS_CLEAR_PAGINATION_INFO';
const RESTAURANTS_EDIT_ENTITY: any = createTypes('RESTAURANTS_EDIT_ENTITY');
const RESTAURANTS_FETCH_EMAIL_AND_PHONE_TYPES: any = createTypes(
  'RESTAURANTS_FETCH_EMAIL_AND_PHONE_TYPES',
);
const RESTAURANTS_CLEAR_EMAIL_AND_PHONE_TYPES_DATA =
  'RESTAURANTS_CLEAR_EMAIL_AND_PHONE_TYPES_DATA';
const SELECTED_RESTAURANTS_LIST = 'SELECTED_RESTAURANTS_LIST';
const RESTAURANTS_CLEAR_ENTITY = 'RESTAURANTS_CLEAR_ENTITY';

export {
  RESTAURANTS_FETCH_EMAIL_AND_PHONE_TYPES,
  RESTAURANTS_CLEAR_EMAIL_AND_PHONE_TYPES_DATA,
  RESTAURANTS_FETCH_ENTITIES,
  RESTAURANTS_FETCH_ENTITY,
  RESTAURANTS_CLEAR_ENTITIES,
  RESTAURANTS_CLEAR_ENTITY,
  RESTAURANTS_SET_ROWS_PER_PAGE,
  RESTAURANTS_SET_PAGE,
  RESTAURANTS_CLEAR_PAGINATION_INFO,
  RESTAURANTS_EDIT_ENTITY,
  SELECTED_RESTAURANTS_LIST,
};
